export default __webpack_public_path__ + "static/media/Icon=City.665c2931.svg";